import { useState } from "react";
import { format } from "date-fns";
import { CalendarIcon, ArrowRight } from "lucide-react";
import { Calendar } from "@/components/ui/calendar";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { toast } from "sonner";

export default function Step1CertificateDetails({ formData, updateForm, onNext }) {
  const [calendarOpen, setCalendarOpen] = useState(false);

  const handleNext = () => {
    if (!formData.certificate_ref.trim()) {
      toast.error("Please enter a Certificate Reference");
      return;
    }
    if (!formData.installation_address.trim()) {
      toast.error("Please enter the Installation Address");
      return;
    }
    if (!formData.description.trim()) {
      toast.error("Please enter a short description of works");
      return;
    }
    if (!formData.installation_date) {
      toast.error("Please select an Installation Date");
      return;
    }
    onNext();
  };

  return (
    <div className="form-container max-w-3xl mx-auto" data-testid="step-1-form">
      <h2
        className="text-2xl sm:text-3xl font-bold tracking-tight mb-2"
        style={{ fontFamily: 'Outfit, sans-serif' }}
      >
        Notification of Completed Works
      </h2>
      <p className="text-sm text-[#71717A] mb-8">
        Please provide the certificate details for the completed works.
      </p>

      <div className="space-y-6">
        {/* Certificate Ref */}
        <div>
          <label className="block text-xs uppercase tracking-[0.2em] font-bold text-[#71717A] mb-2" style={{ fontFamily: 'Outfit, sans-serif' }}>
            Certificate Ref.
          </label>
          <input
            data-testid="certificate-ref-input"
            type="text"
            value={formData.certificate_ref}
            onChange={(e) => updateForm({ certificate_ref: e.target.value })}
            className="brutalist-input"
            placeholder="e.g. CERT-2026-001"
          />
        </div>

        {/* Installation Address */}
        <div>
          <label className="block text-xs uppercase tracking-[0.2em] font-bold text-[#71717A] mb-2" style={{ fontFamily: 'Outfit, sans-serif' }}>
            Installation Address
          </label>
          <input
            data-testid="installation-address-input"
            type="text"
            value={formData.installation_address}
            onChange={(e) => updateForm({ installation_address: e.target.value })}
            className="brutalist-input"
            placeholder="Enter the installation address"
          />
        </div>

        {/* Description */}
        <div>
          <label className="block text-xs uppercase tracking-[0.2em] font-bold text-[#71717A] mb-2" style={{ fontFamily: 'Outfit, sans-serif' }}>
            Short Description of Works Completed
          </label>
          <textarea
            data-testid="description-input"
            value={formData.description}
            onChange={(e) => updateForm({ description: e.target.value })}
            className="brutalist-input min-h-[100px] resize-y"
            placeholder="Briefly describe the electrical works completed"
            rows={4}
          />
        </div>

        {/* Installation Date */}
        <div>
          <label className="block text-xs uppercase tracking-[0.2em] font-bold text-[#71717A] mb-2" style={{ fontFamily: 'Outfit, sans-serif' }}>
            Installation Date
          </label>
          <Popover open={calendarOpen} onOpenChange={setCalendarOpen}>
            <PopoverTrigger asChild>
              <button
                data-testid="installation-date-button"
                className="brutalist-input flex items-center justify-between cursor-pointer"
                type="button"
              >
                <span className={formData.installation_date ? "text-[#0A0A0A]" : "text-[#9CA3AF]"}>
                  {formData.installation_date ? format(formData.installation_date, "dd/MM/yyyy") : "Select date"}
                </span>
                <CalendarIcon className="w-4 h-4 text-[#71717A]" />
              </button>
            </PopoverTrigger>
            <PopoverContent className="w-auto p-0 border-2 border-[#0A0A0A] rounded-none" align="start">
              <Calendar
                mode="single"
                selected={formData.installation_date}
                onSelect={(date) => {
                  updateForm({ installation_date: date });
                  setCalendarOpen(false);
                }}
                initialFocus
              />
            </PopoverContent>
          </Popover>
        </div>
      </div>

      <div className="mt-8 flex justify-end">
        <button
          data-testid="step-1-next-button"
          onClick={handleNext}
          className="brutalist-btn flex items-center gap-2"
        >
          Next <ArrowRight className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
}
